import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { CostCenter } from '../models/cost-center/cost-center';

@Injectable({ providedIn: 'root' })
export class CostCenterProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/cost-center';

  /** The whole tree in one call — the read-only view (#5841) filters it client-side so ancestors of a match stay visible. */
  public getAll(): Observable<ApiResponse<CostCenter[]>> {
    return this.httpClient.get<ApiResponse<CostCenter[]>>(`${this.baseUrl}/all`);
  }
}
